
import { defineComponent, computed, onMounted, getCurrentInstance, PropType } from 'vue'
import { sendLog } from '@/common/radar';
import { getQuery } from '~/common/utils';
import { Feed } from '~/api/feed';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<Feed>,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { proxy }  = getCurrentInstance() || {}
    const origin = window?.location?.origin?? ''

    const jumpLink = computed(() => {
      return `/@${props.item?.kwai_id}/video/${props.item?.photo_id_str}`
    })
    
    const pictureUrl = computed(() => {
      return props?.item?.cover_thumbnail_urls?.[0]?.url ?? ''
    })

    const videoDuration = computed(() => {
      const milliseconds = props?.item?.ext_params?.video || 0
      const seconds = milliseconds / 1000;
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`; 
    })

    const handleCardClick = () => {
      const query = getQuery()
      proxy?.$router?.push({ path: jumpLink.value, query: { ...query, page_source: 'topic' } })
      sendLog({
        type: 'click',
        name: 'PHOTO_TEXT_CARD',
        value: {
          button_type: 'card',
          ...cardCommonParams.value
        }
      })
    }

    const cardCommonParams = computed(() => {
      return {
        pictrue_id: props?.item?.photo_id_str ?? '',
        card_position: props.index,
        type: 'photo',
        isMobile: 'true'
      }
    })

    return { 
      pictureUrl, 
      handleCardClick, 
      origin,
      jumpLink,
      videoDuration,
      cardCommonParams
    }
  }
})
